var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"content-wrapper"},[_c('HeaderRegistered'),_vm._m(0)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"main"},[_c('section',{staticClass:"dashboard-section"},[_c('h2',{staticClass:"title"},[_vm._v(" Coming soon! ")])])])
}]

export { render, staticRenderFns }